import * as React from "react";
import { useEffect, useState } from "react";
import { DialogContent, styled } from "@mui/material";
import { ClinicDialog } from "ask/src/components/clinic/elements/clinicDialog";
// import { FormInput } from "../layout/formInput";
// import { ClinicSmallButton } from "../clinic/clinicActionButton";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { useClinicState } from "ask/src/clinic/clinicStateContext";
import { QuestionTypes } from "rag-chat/src/context/sessionStore";
import { PatientCardAnswerPrompt } from "./patientCardAnswerPrompt";
// import useSessionStore from "rag-chat/src/context/useSessionStore";
// import { copyToClipboard } from "fe-common/utils/copyToClipboard";

//region [[ Styles ]]
const AppointmentSummaryView = styled("div")({
  width: 600,
  paddingTop: 20,
  display: "flex",
  flexDirection: "column",
  gap: 8,
  height: "100%",
  overflow: "hidden",
});

const AppointmentPromptForm = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  transition: "height 0.3s ease-in-out",
  height: "auto",
  overflow: "hidden",
  "&.closed": {
    height: 0,
  },
});

const ButtonsView = styled("div")({
  display: "flex",
  alignItems: "start",
  justifyContent: "flex-end",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface AppointmentSummaryProps {
  open: boolean;
  onClose: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AppointmentSummary = ({
  open,
  onClose,
}: AppointmentSummaryProps) => {
  const [prompt, setPrompt] = useState("");
  //const [submittedPrompt, setSubmittedPrompt] = useState("");
  //const [hidePrompt, setHidePrompt] = useState(true);

  const [{ clinicConfig, rtlDisplay }] = useClinicState();
  const { translate } = useTranslateByGender();

  useEffect(() => {
    if (clinicConfig?.standalone) {
      setPrompt(clinicConfig.standalone.appointmentSummaryPrompt);
    }
  }, [clinicConfig]);

  // const handleGenerate = async () => {
  //   setHidePrompt(true);
  //   setSubmittedPrompt(prompt);
  // };

  return (
    <ClinicDialog
      onClose={onClose}
      closeButton={true}
      open={open}
      maxWidth={"lg"}
      rtlDisplay={rtlDisplay}
      scroll="paper"
      PaperProps={{
        style: { height: "100%" },
      }}
    >
      <DialogContent className={"dialog-content"}>
        <AppointmentSummaryView>
          {/*<AppointmentPromptForm className={hidePrompt ? "closed" : ""}>*/}
          {/*  <strong>{translate("APPOINTMENT_SUMMARY")}</strong>*/}
          {/*  <FormInput*/}
          {/*    value={prompt}*/}
          {/*    disabled={loading}*/}
          {/*    multiline*/}
          {/*    onChange={(e) => {*/}
          {/*      setPrompt(e.target.value);*/}
          {/*    }}*/}
          {/*  />*/}
          {/*  <ButtonsView>*/}
          {/*    <ClinicSmallButton*/}
          {/*      onClick={handleGenerate}*/}
          {/*      label={translate("SEND")}*/}
          {/*      disabled={!prompt || loading}*/}
          {/*    />*/}
          {/*  </ButtonsView>*/}
          {/*</AppointmentPromptForm>*/}
          {prompt && (
            <PatientCardAnswerPrompt
              questionType={QuestionTypes.Summary}
              prompt={prompt}
            />
          )}
        </AppointmentSummaryView>
      </DialogContent>
    </ClinicDialog>
  );
};
